import { motion } from "framer-motion";

const STATS = [
  { value: "4+", label: "Projets numériques réalisés" },
  { value: "100%", label: "Solutions sur mesure" },
  { value: "3+", label: "Secteurs d'activité" },
  { value: "IA + Web", label: "+ Automatisation" },
];

export default function Stats() {
  return (
    <section className="bg-[#0B1F3A] py-20 relative overflow-hidden" data-testid="stats-section">
      <div className="absolute inset-0 bg-dot opacity-20" />
      <div className="relative mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`stat-${i}`}
              className="text-center p-6 rounded-xl border border-white/10 bg-white/5 backdrop-blur"
            >
              <div className="font-heading font-black text-4xl sm:text-5xl text-[#00B8D9] mb-2">{s.value}</div>
              <div className="text-sm text-gray-300 tracking-wide">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
